import React, { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../ApiUrl/meta_api";
import "../css/Home.css";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import CountUp from "react-countup";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import {
  FaBuilding,
  FaLaptopCode,
  FaUserTie,
  FaChalkboardTeacher,
  FaDesktop,
  FaCertificate,
} from "react-icons/fa";
import img from "../../Img/images/home-placement-support.jpeg";
import AOS from "aos";
import "aos/dist/aos.css";
import { Row, Col, Form, Button } from "react-bootstrap";
import Footer from "../../Footer/Footer";

const Home = () => {
  const navigate = useNavigate();
  const [meta, setMeta] = useState({});

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });
    // Directly access about_page from data
    const HomeMeta = data[0]?.home_page;

    // Set meta state if AboutMeta exists
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });
  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: "ease-in-out",
      mirror: true,
    });
  }, []);

  // Course data
  const [courses] = useState([
    {
      id: 1,
      title: "Cybersecurity",
      subtitle: "Network Security / Ethical Hacking / Tools",
      image: require("../../Img/images/Course.Cybersecurity.jpg"),
      description:
        "Learn the foundations of Cybersecurity, explore ethical hacking techniques, master network defense strategies, and work hands-on with popular tools like Wireshark, Nmap, and Metasploit.",
      duration: "30-45 days",
      level: "Intermediate",
    },
    {
      id: 2,
      title: "Data Analytics",
      subtitle: "Data Science / AI / Visualization",
      image: require("../../Img/images/Course.Data-analysis.jpg"),
      description:
        "Master data analysis techniques using Python, Excel, and Power BI. Learn how to clean, analyze, visualize data, and apply AI models to extract meaningful insights and drive decisions.",
      duration: "30-45 days",
      level: "Intermediate",
    },

    {
      id: 3,
      title: "Oracle SQL",
      subtitle: "Database Management / PL/SQL / Queries",
      image: require("../../Img/images/Course.sql.jpg"),
      description:
        "Gain expertise in Oracle SQL and PL/SQL for managing enterprise databases. Learn to write complex queries, design relational schemas, and work with stored procedures and triggers.",
      duration: "30-45 days",
      level: "Intermediate",
    },

    {
      id: 4,
      title: "Power BI",
      subtitle: "Data Visualization / BI Reports / Dashboards",
      image: require("../../Img/images/Course.Powerbi.jpg"),
      description:
        "Learn how to create interactive dashboards and compelling business intelligence reports using Power BI. Connect to various data sources, model data, and deliver actionable insights.",
      duration: "30-45 days",
      level: "Intermediate",
    },
    {
      id: 5,
      title: "Python",
      subtitle: "Programming / Scripting / Automation",
      image: require("../../Img/images/Course.Python.png"),
      description:
        "Learn Python programming from the ground up. Explore scripting, data handling, and automation for web development, data science, and real-world problem-solving.",
      duration: "30-45 days",
      level: "Intermediate",
    },
    {
      id: 6,
      title: "Software Testing",
      subtitle: "Manual / Automation / Selenium",
      image: require("../../Img/images/Course.Software Testing.jpg"),
      description:
        "Master both manual and automated software testing techniques. Learn test case creation, bug tracking, and tools like Selenium, JUnit, and TestNG for quality assurance.",
      duration: "30-45 days",
      level: "Intermediate",
    },
    {
      id: 7,
      title: "Tableau",
      subtitle: "Data Visualization / BI / Dashboards",
      image: require("../../Img/images/Course.Tableau.png"),
      description:
        "Visualize and analyze data using Tableau. Learn how to build interactive dashboards, perform data blending, and turn raw data into actionable business insights.",
      duration: "30-45 days",
      level: "Intermediate",
    },
  ]);

  // Slider ref
  const sliderRef = useRef(null);

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const servicesmap = [
    {
      title: "Corporate Training",
      description:
        "Empower your workforce with our industry-focused corporate training programs tailored to meet your organization's goals.",
      icon: <FaBuilding />,
    },
    {
      title: "Internship Programs",
      description:
        "Gain real-world experience through our structured internship programs designed for students and fresh graduates.",
      icon: <FaLaptopCode />,
    },
    {
      title: "Certification Preparation",
      description:
        "Get exam-ready with our comprehensive certification preparation courses across leading technologies and domains.",
      icon: <FaCertificate />,
    },
    {
      title: "Classroom & Online Training",
      description:
        "Learn from industry experts through our flexible classroom and online training modes tailored to your convenience.",
      icon: <FaChalkboardTeacher />,
    },
    {
      title: "Hands-on Labs",
      description:
        "Boost your skills with real-time experience through our expertly designed hands-on lab training modules.",
      icon: <FaDesktop />,
    },
    {
      title: "Career Guidance",
      description:
        "Get personalized support to identify the right career path based on your strengths and goals.",
      icon: <FaUserTie />,
    },
  ];

  // Testimonial scroll
  const scrollRef = useRef(null);
  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -350 : 350,
        behavior: "smooth",
      });
    }
  };

  // carosul content and img
  const slides = [
    {
      src: require("../../Img/images/Hero banner01.png"),
      title: "Transform Your Career with Berlin Technovation",
      desc: "Leading software and technology education academy in Salem innovation hub",
      btn: "Start Your Journey",
    },
    {
      src: require("../../Img/images/Hero banner02.png"),
      title: "100% Placement Guarantee",
      desc: "Join 1000+ students who secured their dream jobs through our comprehensive programs",
      btn: "View Placement Success",
    },
    {
      src: require("../../Img/images/Hero banner03.png"),
      title: "Industry-Leading Courses",
      desc: "Master cutting-edge technologies with hands-on projects and expert mentorship",
      btn: "Explore Courses",
    },
    {
      src: require("../../Img/images/Hero banner04.png"),
      title: "Corporate Training Excellence",
      desc: "Upskill your team with our customized corporate training programs",
      btn: "Corporate Solutions",
    },
  ];

  const stats = [
    { value: 1000, suffix: "+", label: "Students Placed" },
    { value: 100, suffix: "%", label: "Placement Rate" },
    { value: 50, suffix: "+", label: "Hiring Partners" },
    { value: 95, suffix: "%", label: "Success Rate" },
  ];

  const [startCount, setStartCount] = useState(false);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for your enquiry! We will contact you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      course: "",
      message: "",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const triggerPoint = window.innerHeight / 1.3;
      const statsSection = document.getElementById("stats-section");
      if (
        statsSection &&
        statsSection.getBoundingClientRect().top < triggerPoint
      ) {
        setStartCount(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HelmetProvider>
      <div className="home-container" style={{ overflowX: "hidden" }} id="Home">
        <Helmet>
          <title>{meta?.title || "Home - Berlin Technovation"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Transform Your Career with Berlin Technovation."
            }
          />
        </Helmet>
        <div
          id="carouselExampleDark"
          className="carousel carousel-dark slide "
          data-bs-ride="carousel"
          style={{ position: "relative" }}
        >
          {/* Indicators */}
          <div className="carousel-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
                style={{ backgroundColor: "gray" }}
              ></button>
            ))}
          </div>

          {/* Carousel Slides */}
          <div className="carousel-inner">
            {slides.map((item, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                data-bs-interval="5000"
              >
                <img
                  src={item.src}
                  className="d-block w-100 carousel-img"
                  alt={`Slide ${index + 1}`}
                />

                {/* Caption */}
                <div className="carousel-caption d-flex flex-column justify-content-center align-items-center text-center overlay-bg">
                  <div
                    className="p-4 rounded"
                    data-aos="zoom-in"
                    style={{ maxWidth: "800px" }}
                  >
                    <h2
                      className="carousel-title fs-1 fs-sm-2"
                      style={{ fontFamily: "Figtree, sans-serif" }}
                    >
                      {item.title}
                    </h2>
                    <p className="carousel-desc">{item.desc}</p>
                    <button
                      className="btn text-white"
                      style={{ backgroundColor: "#0763ad", fontSize: "14px" }}
                    >
                      {item.btn}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleDark"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleDark"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        {/* About Section */}
        <section className="about-section" style={{ overflowX: "hidden" }}>
          <div className="container">
            <div className="about-content ">
              <div
                className="about-text"
                data-aos="fade-right"
                data-aos-delay="1000"
              >
                <h2 style={{ color: "#0663ad" }}>
                  About Berlin <span className="text-black">Technovation</span>
                </h2>

                <div className="section-divider mb-3  mx-auto"></div>
                <p style={{ textAlign: "justify" }}>
                  Berlin TechInnovation is a forward-thinking software and
                  technology education academy based in the heart of Salem
                  startup capital. We specialize in providing comprehensive
                  training programs that bridge the gap between academic
                  learning and industry requirements.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Our mission is to empower innovation through advanced software
                  development, AI integration, and cloud technologies. With a
                  dynamic team of industry experts, certified trainers, and
                  career counselors, we transform aspiring professionals into
                  skilled technologists.
                </p>

                <button
                  className="btn   mt-3"
                  style={{ backgroundColor: "#0663ad", color: "white" }}
                  onClick={() => {
                    navigate("/Aboutus");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  About More
                </button>
              </div>

              <div
                className="about-image"
                data-aos="fade-left"
                data-aos-delay="100"
              >
                <div className="image-wrapper">
                  <img
                    src={require("../../Img/images/Home - About us.jpg")}
                    alt="About Berlin Technovation"
                    className="img-fluid"
                  />
                  <div className="stats-overlay">
                    <div
                      className="stat-item"
                      data-aos="zoom-in"
                      data-aos-delay="100"
                    >
                      <h4 style={{ color: "#ffff" }}>10+</h4>
                      <p className="text-white">Years Experience</p>
                    </div>
                    <div
                      className="stat-item"
                      data-aos="zoom-in"
                      data-aos-delay="700"
                    >
                      <h4 style={{ color: "#ffff" }}>1000+</h4>
                      <p>Students Trained</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Courses Section */}
        <section className="courses-section">
          <div className="container">
            <div className="section-header" data-aos="fade-down">
              <h2 style={{ color: "#0663ad" }}>
                Our Popular <span className="text-black">Courses</span>
              </h2>
              <div className="section-divider  mb-3 mx-auto"></div>
            </div>

            <div className="courses-slider" data-aos="zoom-in">
              <div className="slider-controls">
                <button
                  className="slider-arrow prev"
                  onClick={() => sliderRef.current.slickPrev()}
                >
                  <FaArrowLeft />
                </button>
                <button
                  className="slider-arrow next"
                  onClick={() => sliderRef.current.slickNext()}
                >
                  <FaArrowRight />
                </button>
              </div>

              <Slider ref={sliderRef} {...settings}>
                {courses.map((course) => (
                  <div key={course.id} data-aos-delay={course.id * 100}>
                    <div className="course-card ">
                      <div className="course-image">
                        <img src={course.image} alt={course.title} />
                        <div className="course-level">{course.level}</div>
                      </div>
                      <div className="course-content">
                        <h3 style={{ color: "black" }}>{course.title}</h3>
                        <h4 style={{ color: "black" }}>{course.subtitle}</h4>
                        <p
                          className="text-dark"
                          style={{ textAlign: "justify" }}
                        >
                          {course.description}
                        </p>
                        <div className="course-meta mb-1">
                          <span>
                            <i className="bi bi-clock text-black"></i>
                            <span className="text-dark">{course.duration}</span>
                          </span>
                          <button
                            onClick={() => {
                              navigate("/Courses");
                              window.scrollTo({ top: 900, behavior: "smooth" });
                            }}
                            className="btn  px-3  py-2"
                            style={{
                              fontSize: "12px",
                              backgroundColor: "#0663ad",
                              color: "white",
                            }}
                          >
                            View Details <FaArrowRight className="ms-2" />
                          </button>
                          {/* <span>
                          <i className="bi bi-bar-chart"></i>
                          <span className="text-dark">{course.level}</span>
                        </span> */}
                        </div>
                        <h1 className="text-end"></h1>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>

        {/* our service */}
        <section className="py-5">
          <div className="container" id="our-service">
            <h2
              className="text-center fw-bold mb-2"
              style={{ color: "#0663ad" }}
            >
              Our <span className="text-black">Services</span>
            </h2>
            <div className="section-divider  mb-3 mx-auto"></div>

            <div className="row g-4">
              {servicesmap.map((service, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div
                    className="card h-100 shadow border-0 rounded-4 service-card"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    id="service-card"
                  >
                    <div className="card-body text-center p-4">
                      <div
                        className="fs-1 mb-3 service-icon"
                        style={{ color: "#0663ad" }}
                      >
                        {service.icon}
                      </div>
                      <h5 className="card-title mb-2" style={{ color: "" }}>
                        {service.title}
                      </h5>
                      <p className="card-text text-muted small">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section
          className="py-5  position-relative mb-5"
          style={{
            background: "linear-gradient(135deg,rgb(0, 0, 0), #112240)",
          }}
        >
          <div className="container">
            {/* Section Header */}
            <div
              className="text-center mb-5"
              data-aos="fade-down"
              id="placement-support"
            >
              <h2
                className="fw-bold mb-2 mt-3"
                style={{ color: "#008cff", fontSize: "2rem" }}
              >
                Our Placement <span className="text-white">Support</span>
              </h2>
            </div>

            <div className="row g-5 align-items-center">
              {/* Left Side - Support Points */}
              <div className="col-lg-6">
                <ul className="list-unstyled ">
                  {[
                    "Dedicated placement team working with 50+ hiring partners",
                    "Comprehensive interview preparation and mock sessions",
                    "Resume building and portfolio development assistance",
                    "Continuous support until successful job placement",
                    " One-on-one mock HR and technical interviews",
                    "Soft skills training including communication, teamwork, and leadership",
                    "Personalized career guidance and mentorship from industry experts",
                  ].map((point, index) => (
                    <li
                      key={index}
                      className="d-flex align-items-center mb-3"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <span
                        style={{
                          color: "#0663ad",
                          fontSize: "1.1rem",
                          marginRight: "10px",
                          marginTop: "3px",
                        }}
                      >
                        ✔
                      </span>
                      <span
                        style={{
                          fontSize: "1rem",
                          color: "white",
                          lineHeight: "1.6",
                        }}
                      >
                        {point}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Right Side*/}
              <div className="col-lg-6 text-center d-flex justify-content-center">
                <img
                  src={require("../../Img/images/home-placement-support.jpeg")}
                  alt="Our Placement Support"
                  className="img-fluid"
                  style={{
                    height: "510px",
                    width: "100%", // or specify like "600px"
                    maxWidth: "600px", // optional: restrict max size
                    borderRadius: "15px",
                    objectFit: "cover", // ensures image covers area nicely
                  }}
                />
              </div>

              <div className="col-12" id="stats-section">
                <div className="row g-4">
                  {stats.map((item, index) => (
                    <div
                      key={index}
                      className="col-6 col-md-3"
                      data-aos="fade-up"
                      data-aos-delay={100 * (index + 1)}
                    >
                      <div className="stat-card p-3 text-center bg-white shadow-sm h-100 rounded">
                        <div
                          className="stat-value display-5 fw-bold"
                          style={{ color: "#0663ad" }}
                        >
                          {startCount && (
                            <CountUp
                              end={item.value}
                              duration={2}
                              suffix={item.suffix}
                            />
                          )}
                        </div>
                        <div>
                          <span
                            className="stat-label fs-5"
                            style={{ color: "black" }}
                          >
                            {item.label}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="py-5 " id="contact">
          <div class="container">
            <div class="row g-5 align-items-start">
              {/* <!-- Contact Info --> */}
              <div class="col-lg-5" data-aos="fade-right">
                <h2 className="fw-bold mb-2" style={{ color: "#0663ad" }}>
                  Get In <span className="text-black">Touch</span>
                </h2>
                <div className="section-divider ms-5 mb-2 mx-auto"></div>
                <p class="text-muted mb-4">
                  We'd love to hear from you. Reach out for any queries or
                  collaboration.
                </p>

                <div class="d-flex mb-4">
                  <i
                    class="bi bi-geo-alt-fill fs-3 me-3"
                    style={{ color: "#0663ad" }}
                  ></i>
                  <div>
                    <h5 class="mb-1">Address</h5>
                    <p class="mb-0 text-muted">
                      Third Floor, Navanidhi towers, AVR roundana, Junction Main
                      Rd, Salem, Tamil Nadu 636005
                    </p>
                  </div>
                </div>

                <div class="d-flex mb-4">
                  <i
                    class="bi bi-telephone-fill fs-3 me-3"
                    style={{ color: "#0663ad" }}
                  ></i>
                  <div>
                    <h5 class="mb-1">Phone</h5>
                    <p class="mb-0 text-muted">+91 9600 4800 52</p>
                  </div>
                </div>

                <div class="d-flex mb-4">
                  <i
                    class="bi bi-envelope-fill fs-3 me-3"
                    style={{ color: "#0663ad" }}
                  ></i>
                  <div>
                    <h5 class="mb-1">Email</h5>
                    <p class="mb-0 text-muted">hr@berlintechnovation.com</p>
                  </div>
                </div>

                <div class="d-flex">
                  <i
                    class="bi bi-clock-fill fs-3 me-3"
                    style={{ color: "#0663ad" }}
                  ></i>
                  <div>
                    <h5 class="mb-1">Working Hours</h5>
                    <p class="mb-0 text-muted">
                      Monday - Saturday: 9:00 AM - 7:00 PM
                    </p>
                  </div>
                </div>
              </div>

              {/* <!-- Contact Form --> */}
              <div class="col-lg-7" data-aos="fade-left">
                <div class="card shadow border-0">
                  <div class="card-body p-4">
                    <h3 class="mb-4 ">Send us a Message</h3>

                    <Form onSubmit={handleSubmit}>
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              placeholder="Enter your name"
                              required
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              {/* <FaEnvelope className="me-2 text-warning" /> */}
                              Email
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Enter your email"
                              required
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              {/* <FaPhone className="me-2 text-warning" /> */}
                              Phone
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Enter your phone"
                              required
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Course
                            </Form.Label>
                            <Form.Select
                              name="course"
                              value={formData.course}
                              onChange={handleChange}
                              required
                              className="py-2"
                            >
                              <option value="">Select a course</option>
                              <option value="Cybersecurity">
                                Cybersecurity
                              </option>
                              <option value="Data Analytics">
                                Data Analytics
                              </option>
                              <option value="Oracle SQL">Oracle SQL</option>
                              <option value="Power BI">Power BI</option>
                              <option value="Python">Python</option>
                              <option value="Software Testing">
                                Software Testing
                              </option>
                              <option value="Tableau">Tableau</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Tell us about your requirements..."
                          className="py-2"
                        />
                      </Form.Group>

                      <Button
                        type="submit"
                        size="lg"
                        className="w-100 fw-bold"
                        style={{
                          backgroundColor: "#0663ad",
                          borderColor: "#ffc107",
                          color: "white",
                        }}
                      >
                        {/* <FaPaperPlane className="me-2" /> */}
                        Send Message
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section
          className="py-5"
          style={{
            background: "linear-gradient(135deg,rgb(0, 0, 0), #112240)",
          }}
        >
          <div className="container">
            <div className="row align-items-center text-white">
              {/* Left Content */}
              <div className="col-md-4 mb-4 mb-md-0">
                <h2 className="text-white pt-0 mb-2">
                  Our <span style={{ color: "#008cff" }}>Testimonial</span>
                </h2>

                <div className="section-divider ms-5 mb-3 mx-auto"></div>
                <h3 className="fw-bold text-white mb-3">
                  What Students Think and Say About Berlin Technovation
                </h3>
                <p className="text-light">
                  Empowering businesses with cutting-edge technology, reliable
                  support, and seamless integration.
                </p>
              </div>

              {/* Right - Testimonial Card */}
              <div className="col-md-8 position-relative">
                <button
                  className="btn border text-white rounded-circle position-absolute top-50 start-0 translate-middle-y"
                  onClick={() => scroll("left")}
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#0663ad",
                  }}
                >
                  <FaArrowLeft />
                </button>

                <div
                  className="overflow-auto d-flex gap-5 px-4"
                  ref={scrollRef}
                >
                  {[
                    {
                      title: "Interactive Learning Experience",
                      text: `“I've been thoroughly impressed with how engaging and interactive the courses are on this. The use of multimedia, quizzes, and live sessions makes learning enjoyable and keeps me motivated.”`,
                      name: "Henry Baker",
                      role: "Director, Puzzle Huddle",
                      img: require("../../Img/images/palani.png"),
                    },
                    {
                      title: "Supportive Mentorship",
                      text: `“I completed my internship at Brillient. It was a fantastic opportunity to improve my skills in web development. A friendly environment to learn new things in IT field.”`,
                      name: "Palani Pandiyan",
                      role: "Web Developer",
                      img: require("../../Img/images/elavarasi.png"),
                    },
                    {
                      title: "Great Learning Path",
                      text: `“I learned the basics of website development and networking. Your teaching was excellent, and we truly enjoyed the sessions. Thank you!”`,
                      name: "Elavarasi K",
                      role: "UI/UX Designer",
                      img: require("../../Img/images/elavarasi.png"),
                    },
                  ].map((card, index) => (
                    <div
                      key={index}
                      className="bg-white text-dark rounded-4 shadow px-4 py-5"
                      style={{ minWidth: "320px", maxWidth: "360px" }}
                    >
                      <div className="d-flex align-items-center ">
                        <img
                          src={card.img}
                          alt={card.name}
                          className="rounded-circle me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                        <div>
                          <strong>{card.name}</strong>
                          <div
                            className="text-muted"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {card.role}
                          </div>
                        </div>
                      </div>
                      <h5 className="fw-bold mb-3">{card.title}</h5>
                      <p className="text-muted fst-italic">{card.text}</p>
                    </div>
                  ))}
                </div>

                <button
                  className="btn border text-white rounded-circle position-absolute top-50 end-0 translate-middle-y"
                  onClick={() => scroll("right")}
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#0663ad",
                  }}
                >
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Partners Section */}
        <section className="partners-section">
          <div className="container">
            <div className="section-header" data-aos="fade-down">
              <h2 style={{ color: "#0663ad" }}>
                Our <span style={{ color: "black" }}>Partners</span>
              </h2>
              <div className="section-divider  mb-3 mx-auto"></div>
              <p>Trusted by leading organizations</p>
            </div>

            <div className="partners-slider">
              <div className="partners-track">
                {[
                  require("../../Img/images/microsoft.png"),
                  require("../../Img/images/aws.png"),
                  require("../../Img/images/google.png"),
                  require("../../Img/images/oracle.png"),
                  require("../../Img/images/microsoft.png"),
                  require("../../Img/images/aws.png"),
                  require("../../Img/images/google.png"),
                  require("../../Img/images/oracle.png"),
                  require("../../Img/images/microsoft.png"),
                  require("../../Img/images/aws.png"),
                  require("../../Img/images/google.png"),
                  require("../../Img/images/oracle.png"),
                ].map((logo, index) => (
                  <div
                    className="partner-logo"
                    key={index}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <img src={logo} alt={`Partner ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Home;
